import { NotePlusIcon } from './NotePlusIcon';

/**
 * author: Austin Andrews
 * id 753F2E09-A32F-4790-9C07-7CD9AB69104D
 * name note-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-plus.svg
 * tags
 */
export const StickyNoteAddIcon = NotePlusIcon;
export default StickyNoteAddIcon